import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * 로그인 체크 후 미로그인 시 로그인 페이지로, OTP 미인증 시 OTP 페이지로 리다이렉트
 */
function ProtectedRoute({ children, loginPath }) {
  const isLoggedIn = useSelector((state) => state.login.value);
  const otpVerified = useSelector((state) => state.login.otpVerified);
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }
  if (!otpVerified) {
    return <Navigate to={loginPath + '/otp'} state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
